import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=1babb36a&scoped=true&"
import script from "./CollectionList.vue?vue&type=script&lang=ts&"
export * from "./CollectionList.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionList.vue?vue&type=style&index=0&id=1babb36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1babb36a",
  null
  
)

component.options.__file = "CollectionList.vue"
export default component.exports